const isOpenClass = 'modal-is-open';
const openingClass = 'modal-is-opening';
const closingClass = 'modal-is-closing';
const animationDuration = 400; // ms
let visibleModal = null;

// Modal ouverte ?
const isModalOpen = (element) => element.hasAttribute('open') && element.getAttribute('open') !== 'false';

// Fermeture du modal
const closeModal = (element) => {
    visibleModal = null;
    document.documentElement.classList.add(closingClass);

    setTimeout(() => {
        document.documentElement.classList.remove(closingClass, isOpenClass);
        document.documentElement.style.removeProperty('--scrollbar-width');
        element.removeAttribute('open');
    }, animationDuration);
};

// Fermeture du modal avec un clic extérieur
document.addEventListener('click', (event) => {
    if (visibleModal != null) {
        const modalContent = visibleModal.querySelector('article');
        const isClickInside = modalContent.contains(event.target);
        // eslint-disable-next-line no-unused-expressions
        !isClickInside && closeModal(visibleModal);
    }
});

// Fermeture du modal pour avec la touche Esc
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && visibleModal != null) {
        closeModal(visibleModal);
    }
});

// Récupère la largeur de la scrollbar
const getScrollbarWidth = () => {
    // Créer un conteneur invisible
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // force l'affichage de la scrollbar
    outer.style.msOverflowStyle = 'scrollbar'; // nécessaire pour les applications WinJS
    document.body.appendChild(outer);

    // Créer un élément interne et le place dans le conteneur
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calcul de la différence entre la largeur totale du conteneur et la largeur de l'enfant
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

    // Supprime les éléments temporaires du DOM
    outer.parentNode.removeChild(outer);

    return scrollbarWidth;
};

// La scrollbar est visible ?
// eslint-disable-next-line no-restricted-globals
const isScrollbarVisible = () => document.body.scrollHeight > screen.height;

// Ouverture du modal
const openModal = (element) => {
    if (isScrollbarVisible()) {
        document.documentElement.style.setProperty('--scrollbar-width', `${getScrollbarWidth()}px`);
    }

    document.documentElement.classList.add(isOpenClass, openingClass);

    setTimeout(() => {
        visibleModal = element;
        document.documentElement.classList.remove(openingClass);
    }, animationDuration);

    element.setAttribute('open', true);
};

const toggleModal = (event) => {
    event.preventDefault();

    const element = document.getElementById(event.target.getAttribute('data-target'));
    // eslint-disable-next-line no-unused-expressions
    (typeof (element) !== 'undefined' && element != null) && isModalOpen(element) ? closeModal(element) : openModal(element);
};

export default function modal()
{
    // Ouverture modal
    const modalsAction = document.querySelectorAll('.open-modal');

    modalsAction.forEach((element) => {
        element.addEventListener('click', (event) => {
            toggleModal(event);
        });
    });

    // Fermeture modal
    const modalsClose = document.querySelectorAll('.close-modal');

    modalsClose.forEach((element) => {
        element.addEventListener('click', (event) => {
            toggleModal(event);
        });
    });
}
